<template>
  <div class="ddqr-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单性质"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.nature===0">家装</span>
                      <span v-if="scope.row.nature===1">展厅</span>
                      <span v-if="scope.row.nature===2">工程</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="拆单时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.split_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===7&&scope.row.type===5" type="danger">报价驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===7&&scope.row.type!==5" type="warning">待确认</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                      <el-tooltip content="仅非正单订单可代为确认" placement="top">
                        <el-button v-if="scope.row.mark!==0" size="mini" icon="el-icon-document-checked" @click.stop="affirm(scope.row)">代为确认</el-button>
                        <el-button v-if="scope.row.mark===0" size="mini" icon="el-icon-document-checked" @click.stop="affirm(scope.row)">订单驳回</el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editForm.type===0 ? '订单驳回' : '代为确认'"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="拆单详情" prop="spitdetail">
          <el-card shadow="hover" style="font-size: 12px">
            <div>
              <span style="color:#99a9bf">拆单人员：</span>
              <span style="color:#606266">{{editForm.splitname}}</span>
              <span style="color:#99a9bf;margin-left: 20px">拆单时间：</span>
              <span style="color:#606266">{{editForm.splittime}}</span>
            </div>
            <div>
              <span style="color:#99a9bf">拆单结果：</span>
              <span><el-button type="text" @click="getMaterialDetail" icon="el-icon-document" title="点击查看拆单详情">{{editForm.splitfile}}</el-button></span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="确认备注" prop="content">
          <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="附属文件" prop="files">
          <MultiFile v-model="editForm.files"></MultiFile>
        </el-form-item>
        <el-form-item label="附属图片" prop="imgids">
          <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button v-if="editForm.type!==0" type="primary" icon="el-icon-check" :loading="editloading" @click="subEdit('editForm')">立即确认</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="editloading" @click="turn('editForm')">驳回</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="订单拆单详情"
      :visible.sync="materialVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :before-close="closeMaterial"
      :append-to-body="true">
      <div style="height: 490px;width: 100%" v-loading="materialloading">
      <pl-table
        height="490px"
        :datas="materialTableData"
        :data="materialTableData"
        border
        size="small"
        use-virtual
        :pagination-show="false"
        :row-height="45">
        <pl-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed></pl-table-column>
        <pl-table-column prop="area" label="区域" width="120" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="type" label="分类" width="80" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="name" label="名称" width="160" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="material" label="基材" width="80" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="high" label="高/长" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="width" label="宽" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="ply" label="厚" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="num" label="数量" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="val" label="数值" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="unit" label="单位" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="color" label="颜色" width="140" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></pl-table-column>
      </pl-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="materialTableData=[],materialVisible=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderList, confirmOrder, getErpOrderMaterialDetail } from '@/api/erp'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import { getBrandList } from '@/api/work'

export default {
  name: 'ddqr',
  computed: {
    user: getUser
  },
  components: {
    MultiFile,
    MultiImg
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      materialVisible: false,
      materialloading: false,
      materialTableData: [],
      editForm: {
        orderid: '',
        ordername: '',
        content: '',
        files: [],
        imgids: [],
        splitname: '',
        splittime: '',
        splitfile: ''
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }]
      },
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: []
    }
  },
  created() {
    this.getData()
    this.getBrandList()
  },
  methods: {
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        mark: 7,
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    closeMaterial() {
      this.materialTableData = []
      this.materialVisible = false
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.materialVisible = true
      this.materialloading = true
      getErpOrderMaterialDetail({ orderid: this.editForm.orderid }).then(response => {
        this.materialloading = false
        this.materialTableData = response.data
      }).catch(() => {
        this.materialloading = false
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        let tempindex = 0
        let rowspan = 1
        let temp = null
        for (let i = 0; i <= this.materialTableData.length; i++) {
          if (i === 0) {
            tempindex = i
            rowspan = 1
            temp = this.materialTableData[i].area
          } else {
            if (i === this.materialTableData.length) {
              if (rowIndex === tempindex) {
                return {
                  rowspan: rowspan,
                  colspan: 1
                }
              }
            } else {
              if (temp === this.materialTableData[i].area) {
                rowspan++
                if (rowIndex === i) {
                  return {
                    rowspan: 0,
                    colspan: 0
                  }
                }
              } else {
                if (rowIndex === tempindex) {
                  return {
                    rowspan: rowspan,
                    colspan: 1
                  }
                } else {
                  tempindex = i
                  rowspan = 1
                  temp = this.materialTableData[i].area
                }
              }
            }
          }
        }
      }
    },
    affirm(row) {
      this.editRules.content[0].required = false
      this.editForm.type = row.mark
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.imgids = []
      this.editForm.splitname = row.splitname
      this.editForm.splittime = row.split_time
      this.editForm.splitfile = row.split_filename
      this.editVisible = true
    },
    turn(formName) {
      this.editRules.content[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAffirmOrder(0)
        } else {
          return false
        }
      })
    },
    subEdit(formName) {
      this.editRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubAffirmOrder(1)
        } else {
          return false
        }
      })
    },
    SubAffirmOrder(ispass) {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          reason: this.editForm.content,
          ispass: ispass,
          fileStr: this.editForm.files.join(','),
          imgStr: this.editForm.imgids.join(','),
          type: 1
        }
        confirmOrder(data).then(response => {
          let msg = '订单已代为确认'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ddqr-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
